import { TranslateService } from '@ngx-translate/core';
import { SharedModule } from '../shared/models/shared.module';

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { HomeRoutingModule } from './home.routing';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home.component';

import { ComponentsModule } from '../shared/components/components.module';

import { NotificationModule } from '../notification/notification.module';

import { ToolbarModule } from '../toolbar/toolbar.module';
import { AppTransModule } from '../app-trans/app-trans.module';
import { StartSidebarComponent } from '../sidebar/start-sidebar/start-sidebar.component';

import { AdminMenuComponent } from '../menu/admin-menu/admin-menu.component';
import { TopToolbarComponent } from '../toolbar/top-toolbar/top-toolbar.component';

import { FooterComponent } from '../toolbar/footer/footer.component';
import { HomeFooterComponent } from './home-footer/home-footer.component';
import { HomeHeaderComponent } from './home-header/home-header.component';


@NgModule({
  imports: [
    CommonModule,
    HomeRoutingModule,
    ComponentsModule,
    MatProgressSpinnerModule,NotificationModule ,
SharedModule ,
AppTransModule

  ],
  declarations: [HomeComponent, HomeFooterComponent, HomeHeaderComponent
   ]
  ,
  providers: []

})
export class HomeModule { }
